import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import BackLink from '../../../../common/back-link';
import PageTitle from '../../../../common/page-title';
import { getDamagedBarcodeSubmissions } from '../../../../../actions/scans';
import DamagedBarcodeSubmissionsTable from './damaged-barcode-submissions-table';
import DamagedBarcodeSubmissionsSearch from './damaged-barcode-submissions-search';

class DamagedBarcodeSubmissionsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchValue: '',
      status: '',
      page: 1
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getDamagedBarcodeSubmissions(''));
  }

  handleSearch = () => {
    const { dispatch } = this.props;
    const { searchValue, status, page } = this.state;

    dispatch(getDamagedBarcodeSubmissions(searchValue, status, page));
  };

  handlePageChange = (page) => {
    this.setState({ page }, this.handleSearch);
  };

  handleStatusChange = (event) => {
    this.setState({ status: event.target.value });
  };

  handleClear = () => {
    this.setState({
      searchValue: '',
      status: ''
    }, this.handleSearch);
  };

  handleInputChange = (event) => {
    this.setState({ searchValue: event.target.value });
  };

  render() {
    const {
      loading,
      scannerCodes,
      meta,
      paging
    } = this.props;
    const { searchValue, status, page } = this.state;

    return (
      <div className="container-fluid">
        <Row>
          <Col>
            <BackLink href="/admin/scans" />
          </Col>
          <PageTitle>Damaged Barcode Submissions</PageTitle>
          <DamagedBarcodeSubmissionsSearch
            searchValue={searchValue}
            status={status}
            statuses={meta['override-request-statuses']}
            onSearch={this.handleSearch}
            onClear={this.handleClear}
            onInputChange={this.handleInputChange}
            onStatusChange={this.handleStatusChange}
          />
          {loading ? 'Loading...' : (
            <DamagedBarcodeSubmissionsTable
              scannerCodes={scannerCodes}
              paging={paging}
              page={page}
              handlePageChange={this.handlePageChange}
            />
)}
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: !state.scans.fetched && state.scans.fetching,
  scannerCodes: state.scans.scans,
  meta: state.scans.meta,
  paging: state.scans.paging,
});

export default connect(mapStateToProps)(DamagedBarcodeSubmissionsPage);



// WEBPACK FOOTER //
// ./src/components/admin/scans/damaged-barcode-submissions/list/damaged-barcode-submissions-page.jsx